import { State, StateAbbreviations } from '@shared/enums';
import { compactJoin } from '@shared/utilities';

export class StringUtility {
  static formatAddress = (
    address1?: string | null,
    address2?: string | null,
    city?: string | null,
    state?: State | null,
    postalCode?: string | null,
  ) => {
    return compactJoin([
      address1,
      address2,
      compactJoin([
        !city ? '' : `${city},`,
        !state ? '' : StateAbbreviations[state],
        postalCode,
      ], ' '),
    ], '\n');
  };
}